<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" class="btn btn-rounded btn-block-xs-only" style="background: rgb(73, 145, 165); color: #fff;">
            Add Car Park Tenant
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="pageFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterDataChange" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionText: (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'carparkName',
    text: 'Car Park',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'customerType1',
    text: 'Tenant Type',
    table_hide: true,
    form_add_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_input_validation: [],
  },
  {
    key: 'customerID',
    text: 'Tenant',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionText: (option) => {
        let text = option.name + ' (' + option.nationalID + ')';
        if(option.isCompany) {
          return text + ' - Company';
        } else {
          return text + ' - Personal';
        }
        return text;
      }
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'customerName',
    text: 'Tenant Name',
    table_popup: true, 
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `${dataItem.customerName}<br>${dataItem.customerNationalID}`;
    },
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'customerNationalID',
    text: 'Tenant National ID',
    table_hide: true,
    form_add_hide: true,
    form_input_attr: {
      disabled: true,
    },
    form_input_validation: [],
  },
  {
    key: 'customerType2',
    text: 'Type',
    form_hide: true,
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageTenant",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Tenant' },
      ],

      PARAM,
      PARAM_MAP,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageModal'].modalCanEdit = false;
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['pageModal'].formatModalConfirmDeleteTitle = (formData) =>  `Confirm Remove Tenant from Car Park`;
    this.$refs['pageModal'].formatModalConfirmDeleteBody = (formData) =>  `Confirm remove tenant ${formData['customerName']} from ${formData['carparkName']}?`;
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      this.$refs['pageFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['customerID'], response.data);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer data'));
        });
    },
    loadData() {
      this.$refs['pageTable'].setTableLoading();

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          if(this.$refs['pageFilter'].filterValue) {
            response.data = response.data.filter(k => helper.compareID(k['carparkID'], this.$refs['pageFilter'].filterValue));
          }
          response.data.forEach(i => {
            i['_carpark'] = helper.inputSelectFindOption(PARAM_MAP['carparkID'], i.carparkID);
            i['carparkName'] = i['_carpark'] ? i['_carpark'].name : '';
            i['_customer'] = helper.inputSelectFindOption(PARAM_MAP['customerID'], i.customerID);
            if(i['_customer']) {
              i['customerName'] = i['_customer'].name;
              i['customerNationalID'] = i['_customer'].nationalID;
              i['customerType1'] = i['customerType2'] = i['_customer'].isCompany ? 'Company' : 'Personal';
            }
          });
          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        })
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      if(carparkID) {
        url += '/carpark/' + carparkID;
      }
      url += '/tenant/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['pageFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Car Park Tenant', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.PARAM_MAP['customerNationalID']['text'] = tableData[tableDataIndex]['_customer']['isCompany'] ? 'Company Reg. No.' : 'NIRC / Passport No.';

      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['customerName'], tableData[tableDataIndex]);
    },

    onModalAddDataClick(selectedData) {
      let feedbackItem = selectedData.customerName;

      this.$refs['pageModal'].setModalLoading('Adding ' + feedbackItem);
      
      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterValue(selectedData.carparkID);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      let feedbackItem = selectedData.customerName;

      this.$refs['pageModal'].setModalLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          this.getUrl() + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    async onModalDeleteDataClick(selectedData) {
      let feedbackItem = selectedData.customerName;

      // this.$refs['pageModal'].setModalLoading('Checking parking license data for ' + feedbackItem);
      // if(!await this.$http
      //   .get(
      //     helper.SERVER_URL + '/api2/license?customerID=' + selectedData['customerID'] + '&carparkID=' + selectedData['carparkID'],
      //     helper.createAxiosFormConfig()
      //   )
      //   .then(response => {
      //     let resultMeta = helper.processAxiosResponse(this, response);
      //     // response.data = response.data.filter(k => helper.compareID(k.carparkID, selectedData['carparkID']));
      //     return response.data.length === 0;
      //   })) {
      //   this.$refs['pageModal'].setModalError('This tenant profile has associated parking license, unable to delete.');
      //   return;
      // }

      // this.$refs['pageModal'].setModalLoading('Checking parking license application data for ' + feedbackItem);
      // if(!await this.$http
      //   .get(
      //     helper.SERVER_URL + '/api2/request?customerID=' + selectedData['customerID'] + '&carparkID=' + selectedData['carparkID'],
      //     helper.createAxiosFormConfig()
      //   )
      //   .then(response => {
      //     let resultMeta = helper.processAxiosResponse(this, response);
      //     // response.data = response.data.filter(k => helper.compareID(k.carparkID, selectedData['carparkID']));
      //     return response.data.length === 0;
      //   })) {
      //   this.$refs['pageModal'].setModalError('This tenant profile has associated parking license application, unable to delete.');
      //   return;
      // }

      // this.$refs['pageModal'].setModalLoading('Checking tenant entitlement for ' + feedbackItem);
      // if(!await this.$http
      //   .get(
      //     helper.SERVER_URL + '/api2/bay?customerID=' + selectedData['customerID'] + '&carparkID=' + selectedData['carparkID'],
      //     helper.createAxiosFormConfig()
      //   )
      //   .then(response => {
      //     let resultMeta = helper.processAxiosResponse(this, response);
      //     response.data = response.data.filter(k => helper.compareID(k.carparkID, selectedData['carparkID']) && helper.compareID(k.customerID, selectedData['customerID']));
      //     return response.data.length === 0;
      //   })) {
      //   this.$refs['pageModal'].setModalError('This tenant profile has entitled product, unable to delete.');
      //   return;
      // }

      this.$refs['pageModal'].setModalLoading('Checking parking license season data for ' + feedbackItem);
      let season = await this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + selectedData['carparkID'] + '/season',
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })

      this.$refs['pageModal'].setModalLoading('Checking parking license application data for ' + feedbackItem);
      let application = await this.$http
        .get(
          helper.SERVER_URL + '/api2/request?customerID=' + selectedData['customerID'] + '&carparkID=' + selectedData['carparkID'] + '&type1=application',
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })

      for(let app of application) {
        if(app['status1'] === 'Void' || app['status1'] === 'Rejected' || app['status1'] === 'Completed') {
          continue
        }
        let selectedSeason = season.find(k => helper.compareID(k.id, app['seasonID']))
        if(selectedSeason['isTenant']) {
          this.$refs['pageModal'].setModalError('This tenant profile has associated parking license application, unable to delete.');
          return
        }
      }

      this.$refs['pageModal'].setModalLoading('Checking parking license subscription data for ' + feedbackItem);
      let subscription = await this.$http
        .get(
          helper.SERVER_URL + '/api2/lease?customerID=' + selectedData['customerID'] + '&carparkID=' + selectedData['carparkID'],
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })

      for(let app of subscription) {
        if(!helper.compareID(app['carparkID'], selectedData['carparkID'])) {
          continue
        }
        if(!helper.compareID(app['customerID'], selectedData['customerID'])) {
          continue
        }
        if(app['status'] === 'Void' || app['status'] === 'Rejected' || app['status'].startsWith('Terminated')) {
          continue
        }
        let selectedSeason = season.find(k => helper.compareID(k.id, app['seasonID']))
        if(selectedSeason['isTenant']) {
          this.$refs['pageModal'].setModalError('This tenant profile has associated parking license subscription, unable to delete.');
          return
        }
      }

      this.$refs['pageModal'].setModalLoading('Deleting tenant ' + feedbackItem);
      this.$http
        .delete(
          this.getUrl() + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete tenant ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'tenant data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageTenant.vue